<template>
  <div id="mainPage">
    <left-menu />
    <div id="rightMenu">
      <div class="menu-header flex-align">
        <a-tooltip :title="$store.getters.getUserInfo.merchantName">
          <div class="merchant-name">{{ $t('pages_main_053') }}{{ $store.getters.getUserInfo.merchantName }}</div>
        </a-tooltip>
        <div class="cur-list">
          <div
            v-for="(cur, index) in $store.getters.curList"
            :key="index"
            class="cur"
          >
            <a-tooltip v-if="index === 3" placement="bottom">
              <template #title>
                <div>{{ $t('pages_main_025') }}</div>
                <div>{{ $t('pages_main_026') }}</div>
              </template>
              <question-circle-filled class="ic-tip" />
            </a-tooltip>
            <div class="cur-name flex-align">
              <img :src="getCountryLogo(cur.curType)">
              <span>{{ cur.curType }}</span>
            </div>
            <div class="available-amount">
              {{ cur.totalAmount ? parseMoney(cur.totalAmount, cur.curType) : '0.00' }}
            </div>
            <div v-if="cur.freezeAmount !== 0" class="wait-amount">
              <span>{{ $t('pages_main_024') }}{{ parseMoney(cur.freezeAmount, cur.curType) }}</span>
            </div>
          </div>
        </div>
        <a-button
          v-if="$store.getters.curList.length !== 0"
          shape="round"
          type="primary"
          style="font-size: 13px; margin-left: 32px"
          @click="$router.push('/wallet/index')"
        >{{ $t('pages_main_027') }}</a-button>

        <!-- 节假日通知循环显示 -->
        <div v-if="holidayNotifications.length > 0" class="holiday-notification">
          <notification-outlined class="notification-icon" />
          <div class="holiday-display">
            <div
              v-if="currentHolidayItem"
              class="holiday-item-fade"
              :class="{ 'holiday-item-hidden': !holidayVisible }"
              @click="showHolidayDetail(currentHolidayItem)"
            >
              <calendar-outlined class="holiday-icon" />
              <span class="holiday-text">{{ currentHolidayItem.duration + ' ' + currentHolidayItem.title }}</span>
            </div>
          </div>
        </div>
        <div style="margin-left: auto">
          <div
            class="flex-align"
            style="margin-top: 8px"
          >
            <img class="user-header" src="@/assets/images/user-header.png">
            <a-dropdown>
              <a class="merchant-email" @click.prevent>
                {{ $store.getters.getUserInfo.email }}
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item>
                    <a @click="$router.push('/user/account_materials')">{{ $t('pages_router_031') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="$router.push('/user/user_manage')">{{ $t('pages_router_032') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="$router.push('/user/account_security')">{{ $t('pages_router_033') }}</a>
                  </a-menu-item>
                  <!-- <a-menu-item v-if="!['港勤支付', 'ALREMIT'].includes(themeData.main.name)">
                  <a :onclick="'window.open(\''+'http://help.msp.ottpayhk.com/'+'?base='+ baseUrl+'\')'">{{ $t('pages_main_023') }}</a>
                </a-menu-item> -->
                  <a-menu-item>
                    <a @click="signOut">{{ $t('pages_main_028') }}</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
            <global-outlined class="ic-global" style="margin-top: 16px" />
            <language-selector style="margin-top: 16px" />
          </div>
          <div
            v-if="loginTime"
            class="login-time"
          >{{ $t('pages_main_057', [loginTime]) }}</div>
        </div>

      </div>
      <div id="menuContent" class="menu-content" :style="{width: clientWidth < 800 ? '1280px' : 'auto'}">
        <router-view />
      </div>
    </div>

    <!-- 浮动帮助按钮 -->
    <div class="floating-help-btn" @click="toggleHelpMenu">
      <question-circle-outlined class="help-icon" />
    </div>

    <!-- 右侧帮助菜单 -->
    <div class="help-menu-overlay" :class="{ 'active': helpMenuVisible }" @click="closeHelpMenu">
      <div class="help-menu" :class="{ 'active': helpMenuVisible }" @click.stop>
        <div class="help-menu-header">
          <div class="help-title">
            <customer-service-outlined />
            {{ showVideoList ? ($t('pages_main_help_video') || '视频帮助') : ($t('pages_main_help_title') || '帮助中心') }}
          </div>
          <div class="header-actions">
            <arrow-left-outlined v-if="showVideoList" class="back-btn" @click="backToMainMenu" />
            <close-outlined class="close-btn" @click="closeHelpMenu" />
          </div>
        </div>
        <!-- 主帮助菜单 -->
        <div v-if="!showVideoList" class="help-menu-content">
          <div class="help-item" @click="openUserGuide">
            <book-outlined class="help-item-icon" />
            <div class="help-item-text">
              <div class="help-item-title">{{ $t('pages_main_help_guide') || '使用指南' }}</div>
              <div class="help-item-desc">{{ $t('pages_main_help_guide_desc') || '了解平台功能和操作流程' }}</div>
            </div>
          </div>
          <div class="help-item" @click="openVideoHelp">
            <play-circle-outlined class="help-item-icon" />
            <div class="help-item-text">
              <div class="help-item-title">{{ $t('pages_main_help_video') || '视频帮助' }}</div>
              <div class="help-item-desc">{{ $t('pages_main_help_video_desc') || '观看操作演示视频' }}</div>
            </div>
            <right-outlined class="arrow-icon" />
          </div>
        </div>

        <!-- 视频列表页面 -->
        <div v-else class="video-list-content">
          <div class="video-categories">
            <div class="category-section">
              <div
                v-for="video in videoList.filter(v => v.category === 'basic')"
                :key="video.id"
                class="video-item-compact"
                @click="playVideo(video)"
              >
                <div class="video-icon">
                  <play-circle-outlined />
                </div>
                <div class="video-info-compact">
                  <div class="video-title-compact">{{ $t(video.title) }}</div>
                  <div class="video-meta-compact">
                    <span class="video-duration-compact">{{ $i18n.locale === 'zh' ? video.cnDuration : video.enDuration }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="category-section">
              <h4 class="category-title">{{ $t('pages_help_video_advanced') || '高级功能' }}</h4>
              <div
                v-for="video in videoList.filter(v => v.category === 'advanced')"
                :key="video.id"
                class="video-item-compact"
                @click="playVideo(video)"
              >
                <div class="video-icon">
                  <play-circle-outlined />
                </div>
                <div class="video-info-compact">
                  <div class="video-title-compact">{{ video.title }}</div>
                  <div class="video-meta-compact">
                    <span class="video-duration-compact">{{ video.duration }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="category-section">
              <h4 class="category-title">{{ $t('pages_help_video_troubleshooting') || '问题解决' }}</h4>
              <div
                v-for="video in videoList.filter(v => v.category === 'troubleshooting')"
                :key="video.id"
                class="video-item-compact"
                @click="playVideo(video)"
              >
                <div class="video-icon">
                  <play-circle-outlined />
                </div>
                <div class="video-info-compact">
                  <div class="video-title-compact">{{ video.title }}</div>
                  <div class="video-meta-compact">
                    <span class="video-duration-compact">{{ video.duration }}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 视频播放模态框 -->
    <a-modal
      v-model:visible="videoModalVisible"
      :title="currentVideo?.title ? $t(currentVideo.title) : ''"
      width="800px"
      :footer="null"
      centered
      :z-index="2000"
      @cancel="closeVideoModal"
    >
      <div class="video-player">
        <video
          v-if="currentVideo?.enVideoUrl || currentVideo?.cnVideoUrl"
          :src="$i18n.locale === 'zh' ? currentVideo?.cnVideoUrl : currentVideo?.enVideoUrl"
          controls
          autoplay
          width="100%"
          height="400"
        >
          {{ $t('pages_help_video_unsupported') }}
        </video>
        <div v-else class="video-placeholder">
          <video-camera-outlined />
          <p>{{ $t('pages_help_video_loading') }}</p>
        </div>
      </div>
      <div class="video-description">
        <h4>{{ $t('pages_help_video_description') }}</h4>
        <p>{{ currentVideo?.description ? $t(currentVideo.description) : '' }}</p>
      </div>
    </a-modal>

    <!-- 节假日详情弹窗 -->
    <a-modal
      v-model:visible="holidayDetailVisible"
      :title="$t('pages_main_holiday_detail_title') || '节假日详情'"
      width="600px"
      :footer="null"
      centered
      :z-index="2000"
    >
      <div class="holiday-detail">
        <div class="holiday-date">
          <calendar-outlined />
          <span>{{ selectedHoliday?.duration }}</span>
        </div>
        <div class="holiday-content">
          <p style="white-space: pre-line;">{{ formatHolidayContent(selectedHoliday?.content) }}</p>
        </div>
        <!-- affected currency -->
        <div v-if="selectedHoliday?.currency" class="holiday-currency">
          <span>{{ $t('pages_main_holiday_detail_currency') }}: {{ selectedHoliday?.currency }}</span>
        </div>
        <div class="holiday-notice">
          <exclamation-circle-outlined />
          <span>{{ $t('pages_main_holiday_detail_notice') }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, inject, onUnmounted, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import LeftMenu from './leftMenu/index'
import { _login, _user } from '@/api/index'
import { getCountryLogo, parseMoney, localStorageClear } from '@/util'
import { useStore } from 'vuex'
import Cookies from 'js-cookie'
import LangSelector from '@/components/lang-sel'
export default defineComponent({
  name: 'MainPage',
  components: {
    'left-menu': LeftMenu,
    'language-selector': LangSelector
  },
  setup() {
    let timer = null
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      themeData: inject('$themeData'),
      clientWidth: 0,
      loginTime: null,
      currentTime: new Date().getTime(),
      baseUrl: window.location.protocol + '//' + window.location.host,
      helpMenuVisible: false,
      showVideoList: false,
      currentVideo: null,
      videoModalVisible: false,
      videoList: [
        {
          id: 0,
          title: 'pages_help_video_receivable_management',
          description: 'pages_help_video_desc_receivable_management',
          enDuration: '0:21',
          cnDuration: '0:38',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%94%B6%E6%AC%BE%E4%BA%BA%E7%AE%A1%E7%90%86%E8%8B%B1%E6%96%87.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%94%B6%E6%AC%BE%E4%BA%BA%E7%AE%A1%E7%90%86.mp4'
        },
        {
          id: 1,
          title: 'pages_help_video_add_payee',
          description: 'pages_help_video_desc_add_payee',
          enDuration: '1:24',
          cnDuration: '1:14',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%96%B0%E5%A2%9E%E6%94%B6%E6%AC%BE%E4%BA%BA%E8%8B%B1%E6%96%87.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%96%B0%E5%A2%9E%E6%94%B6%E6%AC%BE%E4%BA%BA.mp4'
        },
        {
          id: 2,
          title: 'pages_help_video_balance_query',
          description: 'pages_help_video_desc_balance_query',
          enDuration: '0:12',
          cnDuration: '0:24',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BD%99%E9%A2%9D%E6%9F%A5%E8%AF%A2%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BD%99%E9%A2%9D%E6%9F%A5%E8%AF%A2.mp4'
        },
        {
          id: 3,
          title: 'pages_help_video_same_name_payment',
          description: 'pages_help_video_desc_same_name_payment',
          enDuration: '0:42',
          cnDuration: '0:34',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE.mp4'
        },
        {
          id: 4,
          title: 'pages_help_video_diff_name_payment',
          description: 'pages_help_video_desc_diff_name_payment',
          enDuration: '0:35',
          cnDuration: '0:42',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%8F%91%E8%B5%B7%E9%9D%9E%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E4%BB%98%E6%AC%BE%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%8F%91%E8%B5%B7%E9%9D%9E%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E4%BB%98%E6%AC%BE.mp4'
        },
        {
          id: 5,
          title: 'pages_help_video_payment_review',
          description: 'pages_help_video_desc_payment_review',
          enDuration: '0:19',
          cnDuration: '0:27',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E5%A4%8D%E6%A0%B8%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E5%A4%8D%E6%A0%B8.mp4'
        },
        {
          id: 6,
          title: 'pages_help_video_payment_details',
          description: 'pages_help_video_desc_payment_details',
          enDuration: '0:12',
          cnDuration: '0:36',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E6%98%8E%E7%BB%86%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E6%98%8E%E7%BB%86.mp4'
        },
        {
          id: 7,
          title: 'pages_help_video_currency_exchange',
          description: 'pages_help_video_desc_currency_exchange',
          enDuration: '0:44',
          cnDuration: '0:44',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%A4%96%E5%B8%81%E5%85%91%E6%8D%A2%E8%8B%B1%E6%96%87%E7%89%88.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%A4%96%E5%B8%81%E5%85%91%E6%8D%A2.mp4'
        },
        {
          id: 8,
          title: 'pages_help_video_financial_management',
          description: 'pages_help_video_desc_financial_management',
          enDuration: '0:30',
          cnDuration: '0:26',
          category: 'basic',
          enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86%E8%8B%B1%E6%96%87.mp4',
          cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86.mp4'
        }
      ],
      // 节假日通知数据 - 将从后台API读取
      holidayNotifications: [],
      currentHolidayIndex: 0,
      currentHolidayItem: null,
      holidayVisible: true, // 控制淡入淡出的可见性
      holidayTimer: null,
      holidayDetailVisible: false,
      selectedHoliday: null
    })
    onMounted(() => {
      state.clientWidth = document.documentElement.clientWidth
    })
    onUnmounted(() => {
      window.onmousemove = null
      clearInterval(timer)
      stopHolidayRotation() // 清理节假日通知定时器
    })
    const init = async () => {
      loadMouseWatch()
      loadLoginTime()
      loadTimer()
      store.dispatch('getCurList')
      // 加载节假日通知
      await loadHolidayNotifications()
    }

    // 模拟从后台API加载节假日通知
    const loadHolidayNotifications = async () => {
      const formatDate = (date) => {
        // date is yyyyMMdd format, convert to yyyy-MM-dd
        if (!date || date.length !== 8) return date
        return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6)}`
      }

      const formatTitle = (title) => {
        // split by |
        if (!title) return ''
        const parts = title.split('|')
        const cnTitle = parts[0] || ''
        const enTitle = parts[1] || ''
        const locale = localStorage.getItem('locale-language') || 'en'
        return locale === 'zh' ? cnTitle : enTitle
      }

      const formatContent = (data) => {
        const content = ''
        const cnContent = data.notifyCn
        const enContent = data.notifyEn

        const locale = localStorage.getItem('locale-language') || 'en'
        if (locale === 'zh') {
          return cnContent || enContent || content
        }
        return enContent || cnContent || content
      }

      const formatDuration = (duration) => {
        // original format: 2025-10-01 -- 2025-10-08
        return duration
      }

      try {
        // 这里应该调用真实的API
        const response = await _user.queryRecentHolidays()
        if (!response.data.succ) {
          state.holidayNotifications = []
          return
        }

        for (let i = 0; i < response.data.data.length; i++) {
          const item = {
            date: formatDate(response.data.data[i].holidayDate),
            content: formatContent(response.data.data[i]),
            currency: response.data.data[i].currency || '',
            title: formatTitle(response.data.data[i].remark),
            duration: formatDuration(response.data.data[i].duration || '')
          }

          state.holidayNotifications.push(item)
        }

        // 数据加载完成后启动旋转显示
        if (state.holidayNotifications.length > 0) {
          startHolidayRotation()
        }

        console.log('Holiday notifications loaded:', state.holidayNotifications.length)
      } catch (error) {
        console.error('Failed to load holiday notifications:', error)
        state.holidayNotifications = [] // 失败时设为空数组
      }
    }
    const signOut = async () => {
      await _login.loginOut()
      Cookies.remove('last_page_name')
      Cookies.remove('SESSION_ID')
      localStorageClear()
      router.replace('/login')
    }
    const loadTimer = () => {
      timer = setInterval(() => {
        loadIsExpired()
      }, 5000)
    }
    const loadIsExpired = () => {
      if (new Date().getTime() - state.currentTime > 5 * 1000 * 60) {
        clearInterval(timer)
        router.push('/user_leave')
      }
    }
    const loadMouseWatch = () => {
      window.onmousemove = () => {
        state.currentTime = new Date().getTime()
      }
    }
    const loadLoginTime = async () => {
      const res = await _login.queryLastLoginDate()
      if (res.data.succ) state.loginTime = res.data.data.lastLoginDate
    }

    // 帮助菜单相关方法
    const toggleHelpMenu = () => {
      state.helpMenuVisible = !state.helpMenuVisible
    }

    const closeHelpMenu = () => {
      state.helpMenuVisible = false
      state.showVideoList = false
    }

    const backToMainMenu = () => {
      state.showVideoList = false
    }

    const playVideo = (video) => {
      state.currentVideo = video
      state.videoModalVisible = true
    }

    const closeVideoModal = () => {
      state.videoModalVisible = false
      state.currentVideo = null
    }

    const openUserGuide = () => {
      // 打开使用指南
      // const guideUrl = state.baseUrl + '/help/guide'
      // window.open(guideUrl, '_blank')
      const cnHelpPdfUrl = 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/EASYWAY%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
      const enHelpPdfUrl = 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/Easyway%20Operation%20Manual%20English%20version.pdf'
      // according language, open different pdf
      const lang = localStorage.getItem('locale-language') || 'zh'
      const helpPdfUrl = lang === 'zh' ? cnHelpPdfUrl : enHelpPdfUrl
      window.open(helpPdfUrl, '_blank')

      // closeHelpMenu()
    }

    const openVideoHelp = () => {
      // 显示视频帮助二级页面
      state.showVideoList = true
    }

    const contactSupport = () => {
      // 联系客服 - 可以打开在线客服窗口或跳转到联系页面
      const supportUrl = state.baseUrl + '/help/contact'
      window.open(supportUrl, '_blank')
      closeHelpMenu()
    }

    const openFeedback = () => {
      // 打开反馈页面
      const feedbackUrl = state.baseUrl + '/help/feedback'
      window.open(feedbackUrl, '_blank')
      closeHelpMenu()
    }

    // 节假日通知相关方法
    const startHolidayRotation = () => {
      if (state.holidayNotifications.length === 0) return

      // 设置第一个通知
      state.currentHolidayIndex = 0
      state.currentHolidayItem = state.holidayNotifications[0]
      state.holidayVisible = true

      // 清除已有定时器
      if (state.holidayTimer) {
        clearInterval(state.holidayTimer)
      }

      // 如果只有一个通知，不需要循环
      if (state.holidayNotifications.length === 1) return

      // 设置定时器，实现淡入淡出切换
      state.holidayTimer = setInterval(() => {
        // 开始淡出
        state.holidayVisible = false

        // 500ms后切换内容并淡入
        setTimeout(() => {
          state.currentHolidayIndex = (state.currentHolidayIndex + 1) % state.holidayNotifications.length
          state.currentHolidayItem = state.holidayNotifications[state.currentHolidayIndex]
          state.holidayVisible = true
        }, 500)
      }, 5000)
    }

    const stopHolidayRotation = () => {
      if (state.holidayTimer) {
        clearInterval(state.holidayTimer)
        state.holidayTimer = null
      }
    }

    const showHolidayDetail = (holiday) => {
      state.selectedHoliday = holiday
      state.holidayDetailVisible = true
    }

    const formatHolidayContent = (content) => {
      if (!content) return ''
      // 处理各种可能的换行符格式
      return content
        .replace(/\\n/g, '\n') // 转换字符串字面量 \n
        .replace(/\\r\\n/g, '\n') // 转换 \r\n
        .replace(/\r\n/g, '\n') // 转换真正的 \r\n
        .replace(/\r/g, '\n') // 转换单独的 \r
    }

    const openDownload = () => {
      // 打开资料下载页面
      const downloadUrl = state.baseUrl + '/help/download'
      window.open(downloadUrl, '_blank')
      closeHelpMenu()
    }

    init()
    return {
      getCountryLogo,
      parseMoney,
      signOut,
      init,
      loadHolidayNotifications,
      toggleHelpMenu,
      closeHelpMenu,
      backToMainMenu,
      openUserGuide,
      openVideoHelp,
      playVideo,
      closeVideoModal,
      contactSupport,
      openFeedback,
      openDownload,
      startHolidayRotation,
      stopHolidayRotation,
      showHolidayDetail,
      formatHolidayContent,
      ...toRefs(state)
    }
  }
})
</script>
<style lang="less" scoped>
  #mainPage {
    display: flex;
    #rightMenu {
      width: 100%;
      background: #F8F9FB;
      height: 100vh;
      overflow-y: scroll;
      .menu-header {
        background: #fff;
        padding: 8px 24px 8px 8px;
        white-space: nowrap;
        height: 80px;
        position: relative;
        .merchant-name {
          font-size: 16px;
          font-weight: 600;
          color: #000;
          position: absolute;
          right: 28px;
          top: 8px;
          width: 400px;
          text-align: right;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .cur-list {
          display: flex;
          margin-left: 24px;
          font-weight: 500;
          .cur {
            padding: 0 36px;
            border-right: 1px solid #ECEFFC;
            text-align: left;
            position: relative;
            .ic-tip {
              color: @main-color;
              top: 2px;
              right: 2px;
              font-size: 15px;
              position: absolute;
            }
            .cur-name {
              img {
                width: 21px;
                height: 14px;
              }
              span {
                margin-left: 8px;
              }
            }
            .wait-amount {
              color: @text-color;
              font-size: 10px;
            }
          }
          .cur:first-child {
            padding-left: 0px;
          }
          .cur:last-child {
            border-right: 0;
          }
        }
        .help-center {
          font-size: 13px;
          color: #1F223E;
          margin-top: 16px;
          cursor: pointer;
          img {
            width: 18px;
            margin: 0 5px 0 24px;
          }
        }
        .user-header {
          width: 30px;
          height: 30px;
          margin: 16px 0 0 24px;
        }
        .merchant-email {
          margin: 16px 24px 0 8px;
          font-size: 13px;
          text-align: left;
          color: #1F223E;
          position: relative;
        }
        .login-time {
          font-size: 11px;
          text-align: right;
        }
      }
      .menu-content {
        padding: 18px 128px;
        height: calc(100vh - 75px);
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }

  // 浮动帮助按钮样式
  .floating-help-btn {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 56px;
    height: 56px;
    background: @main-color;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    z-index: 1000;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }

    .help-icon {
      color: white;
      font-size: 24px;
    }
  }

  // 帮助菜单覆盖层
  .help-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;

    &.active {
      opacity: 1;
      visibility: visible;
    }
  }

  // 右侧帮助菜单
  .help-menu {
    position: fixed;
    top: 0;
    right: 0;
    width: 380px;
    height: 100%;
    background: white;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1002;

    &.active {
      transform: translateX(0);
    }

      .help-menu-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 24px;
        border-bottom: 1px solid #f0f0f0;
        background: #fafafa;

        .help-title {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 600;
          color: #1f223e;

          .anticon {
            margin-right: 8px;
            color: @main-color;
            font-size: 20px;
          }
        }

        .header-actions {
          display: flex;
          align-items: center;
          gap: 12px;

          .back-btn {
            font-size: 16px;
            color: #666;
            cursor: pointer;
            padding: 4px;

            &:hover {
              color: @main-color;
            }
          }

          .close-btn {
            font-size: 16px;
            color: #999;
            cursor: pointer;
            padding: 4px;

            &:hover {
              color: #666;
            }
          }
        }
      }    .help-menu-content {
      padding: 16px 0;

      .help-item {
        display: flex;
        align-items: center;
        padding: 16px 24px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f5f5f5;
        }

        .help-item-icon {
          width: 40px;
          height: 40px;
          background: #f0f8ff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          color: @main-color;
          font-size: 18px;
        }

        .help-item-text {
          flex: 1;

          .help-item-title {
            font-size: 16px;
            font-weight: 500;
            color: #1f223e;
            margin-bottom: 4px;
          }

          .help-item-desc {
            font-size: 12px;
            color: #999;
            line-height: 1.4;
          }
        }
      }
    }
  }

  .help-menu-content {
    padding: 16px 0;

    .help-item {
      display: flex;
      align-items: center;
      padding: 16px 24px;
      cursor: pointer;
      transition: background-color 0.2s ease;
      position: relative;

      &:hover {
        background-color: #f5f5f5;
      }

      .help-item-icon {
        width: 40px;
        height: 40px;
        background: #f0f8ff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        color: @main-color;
        font-size: 18px;
      }

      .help-item-text {
        flex: 1;

        .help-item-title {
          font-size: 16px;
          font-weight: 500;
          color: #1f223e;
          margin-bottom: 4px;
        }

        .help-item-desc {
          font-size: 12px;
          color: #999;
          line-height: 1.4;
        }
      }

      .arrow-icon {
        color: #ccc;
        font-size: 12px;
        margin-left: 8px;
      }
    }
  }

  // 视频列表样式
  .video-list-content {
    padding: 16px 0;
    max-height: calc(100vh - 140px);
    overflow-y: auto;

    .video-categories {
      .category-section {
        margin-bottom: 24px;

        .category-title {
          font-size: 14px;
          font-weight: 600;
          color: #666;
          margin: 0 0 12px 24px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .video-item-compact {
          display: flex;
          align-items: center;
          padding: 12px 24px;
          cursor: pointer;
          transition: background-color 0.2s ease;

          &:hover {
            background-color: #f5f5f5;
          }

          .video-icon {
            width: 32px;
            height: 32px;
            background: #f0f8ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            color: @main-color;
            font-size: 14px;
          }

          .video-info-compact {
            flex: 1;

            .video-title-compact {
              font-size: 14px;
              font-weight: 500;
              color: #1f223e;
              margin-bottom: 2px;
              line-height: 1.3;
            }

            .video-meta-compact {
              font-size: 11px;
              color: #999;

              .video-duration-compact {
                background: #e6f7ff;
                color: @main-color;
                padding: 1px 6px;
                border-radius: 8px;
                font-weight: 500;
              }
            }
          }
        }
      }
    }
  }

  // 视频播放器样式
  .video-player {
    margin-bottom: 20px;

    video {
      border-radius: 8px;
    }

    .video-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 400px;
      background: #f5f5f5;
      border-radius: 8px;
      color: #999;

      .anticon {
        font-size: 48px;
        margin-bottom: 12px;
      }
    }
  }

  .video-description {
    h4 {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
      color: #1f223e;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      color: #666;
      margin: 0;
    }
  }

  // 节假日通知样式
  .holiday-notification {
    margin-left: 24px;
    width: 400px;
    height: 40px;
    border: 2px dashed #4480b8;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 40px; // 为通知图标留出空间

    .notification-icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
      color: #4480b8;
      z-index: 2;
    }

    .holiday-display {
      display: flex;
      flex-direction: column;
      position: absolute;
      width: calc(100% - 40px); // 减去通知图标的宽度
      left: 40px;

      .holiday-item-fade {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center; // 水平居中
        padding: 0 16px;
        cursor: pointer;
        transition: opacity 0.5s ease-in-out;
        white-space: nowrap;
        opacity: 1;

        &.holiday-item-hidden {
          opacity: 0;
        }

        &:hover {
          background: rgba(24, 144, 255, 0.1);
        }

        .holiday-icon {
          margin-right: 8px;
          font-size: 16px;
          color: #1890ff;
        }

        .holiday-text {
          color: #1890ff;
          font-size: 13px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  // 节假日详情弹窗样式
  .holiday-detail {
    .holiday-date {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      color: #4480b8;
      font-weight: 500;

      .anticon {
        margin-right: 8px;
        font-size: 16px;
      }
    }

    .holiday-content {
      margin-bottom: 16px;
      line-height: 1.6;
      color: #333;
    }

    .holiday-currency {
      margin-bottom: 16px;
      font-weight: 500;
      color: #1f223e;
    }

    .holiday-notice {
      display: flex;
      align-items: flex-start;
      padding: 12px;
      background: #fff7e6;
      border: 1px solid #ffd591;
      border-radius: 6px;
      color: #d48806;

      .anticon {
        margin-right: 8px;
        margin-top: 2px;
        font-size: 16px;
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .help-menu {
      width: 100%;
    }

    .floating-help-btn {
      bottom: 20px;
      right: 20px;
      width: 48px;
      height: 48px;

      .help-icon {
        font-size: 20px;
      }
    }

    .holiday-notification {
      width: 200px;
      margin-left: 12px;
    }
  }
</style>

